import cs from "./locale/cs.json";
import de from "./locale/de.json";
import en from "./locale/en.json";
import es from "./locale/es.json";
import fr from "./locale/fr.json";
import he from "./locale/he.json";
import it from "./locale/it.json";
import iw from "./locale/iw.json";
import ja from "./locale/ja.json";
import ko from "./locale/ko.json";
import pt from "./locale/pt.json";
import ru from "./locale/ru.json";
import sk from "./locale/sk.json";
import th from "./locale/th.json";
import tr from "./locale/tr.json";
import vi from "./locale/vi.json";
import zhHK from "./locale/zh-HK.json";
import zhTW from "./locale/zh-TW.json";
import zh from "./locale/zh.json";

export default {
  cs,
  de,
  en,
  es,
  fr,
  he,
  it,
  iw,
  ja,
  ko,
  pt,
  ru,
  sk,
  th,
  tr,
  vi,
  "zh-HK": zhHK,
  "zh-TW": zhTW,
  zh,
};
